export const OLD_TITLE_SPONSORED_SLUG = 'OLD_TITLE_SPONSORED_SLUG';
export const NEW_TITLE_SPONSORED_SLUG = 'NEW_TITLE_SPONSORED_SLUG';
export const NEW_TITLE_NO_SLUG = 'NEW_TITLE_NO_SLUG';
export const NEW_TITLE_ALT_SLUG = 'NEW_TITLE_ALT_SLUG';

export const SVC_OPTIONS_NEW_TITLE = 'Service options in this area';
export const SVC_OPTIONS_OLD_TITLE = 'Services availability';
export const SENTRY_ADS_DSN =
    'https://0f21e964c35ffca9044b50e357c47cd9@o168728.ingest.us.sentry.io/4509407271518208';
export const SENTRY_PROJECT_NAME = 'mst-ads-mfe';
